import { components } from './openapi-schema';

export type ProblemDetails = components['schemas']['ProblemDetails'];

export function formatErrorMessage(message: string, error: unknown): string {
  if (isProblemDetails(error)) {
    if (error.detail) {
      return `${message}: ${error.detail}`;
    } else if (error.status === 500) {
      return `${message}: Internal server error`;
    }
  }

  return message;
}

function isProblemDetails(error: unknown): error is ProblemDetails {
  return (
    typeof error === 'object' &&
    error !== null &&
    'title' in error &&
    'status' in error
  );
}
